module.exports = __webpack_public_path__ + "img/alfa-logo.fc8196d6.jpg";